import { Link } from "react-router-dom";
import { BRAND, BRAND_LOGO_URL } from "@/constants/site";

const LOGO_SRC = BRAND_LOGO_URL;

interface LogoProps {
  tone?: "dark" | "light";
  to?: string;
  className?: string;
}

/**
 * Marca da NXHOST (logotipo em imagem). O logo tem fundo transparente,
 * por isso funciona tanto no topo transparente quanto no rodapé escuro.
 * A prop `tone` é mantida por compatibilidade com os pontos de uso.
 */
export default function Logo({ to = "/", className = "" }: LogoProps) {
  return (
    <Link
      to={to}
      aria-label={BRAND}
      className={`flex shrink-0 items-center transition-opacity hover:opacity-90 ${className}`}
    >
      <img
        src={LOGO_SRC}
        alt={BRAND}
        title="NXHOST - Hospedagem de sites, servidores e soluções digitais"
        className="h-10 w-auto object-contain md:h-11"
      />
    </Link>
  );
}